module.exports = __webpack_public_path__ + "static/media/up-arrow-black.49360158.svg";